/* ==========================================================================
   STRYP Homepage — Vanilla JS
   Scoped to .stryp-homepage. No jQuery. No external deps.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('.stryp-homepage');
  if (!root) return;

  /* ------------------------------------------------------------------------
     1. Sticky nav CTA swap on scroll
        - Watches the Hero CTA. When it leaves the viewport, the nav CTA
          flips to red "SUBSCRIBE — $23.99/MO →".
     ------------------------------------------------------------------------ */
  var navCta  = root.querySelector('[data-stryp-nav-cta]');
  var heroCta = root.querySelector('[data-stryp-hero-cta]');

  if (navCta && heroCta && 'IntersectionObserver' in window) {
    var defaultLabel   = navCta.textContent.trim() || 'SHOP →';
    var scrolledLabel  = 'SUBSCRIBE — $23.99/MO →';

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          navCta.classList.remove('is-scrolled');
          navCta.textContent = defaultLabel;
        } else {
          navCta.classList.add('is-scrolled');
          navCta.textContent = scrolledLabel;
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });

    io.observe(heroCta);
  }

  /* ------------------------------------------------------------------------
     2. Mobile hamburger toggle
     ------------------------------------------------------------------------ */
  var burger = root.querySelector('.stryp-nav__burger');
  var menu   = document.getElementById('stryp-mobile-menu');

  if (burger && menu) {
    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      if (open) {
        menu.setAttribute('hidden', '');
        document.body.style.overflow = '';
      } else {
        menu.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      }
    });

    // Close menu when any link inside is tapped
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        burger.setAttribute('aria-expanded', 'false');
        menu.setAttribute('hidden', '');
        document.body.style.overflow = '';
      });
    });
  }

  /* ------------------------------------------------------------------------
     3. FAQ accordion
        Native <details>/<summary> handles open/close. We just ensure only
        one panel is open at a time for a cleaner feel.
     ------------------------------------------------------------------------ */
  var faqItems = root.querySelectorAll('.stryp-faq__item');
  faqItems.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        faqItems.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      }
    });
  });

  /* ------------------------------------------------------------------------
     4. Scroll fade-in for sections (progressive enhancement)
     ------------------------------------------------------------------------ */
  if ('IntersectionObserver' in window) {
    var reveal = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    root.querySelectorAll('[data-stryp-reveal]').forEach(function (el) {
      reveal.observe(el);
    });
  }

  /* ------------------------------------------------------------------------
     5. Recharge subscribe hook (placeholder)
        Expects data-stryp-subscribe elements to wire into Recharge once the
        app is installed. Replace the selector logic with Recharge's official
        add-to-cart pattern when the app is live.
     ------------------------------------------------------------------------ */
  var subscribeButtons = root.querySelectorAll('[data-stryp-subscribe]');
  subscribeButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      // TODO: integrate Recharge Subscriptions widget.
      // For now, fall through to href / form submit so the link still works.
      if (!btn.dataset.strypReady) {
        // eslint-disable-next-line no-console
        console.info('[STRYP] Recharge subscribe hook — wire to Recharge after app install.');
      }
    });
  });

  /* ------------------------------------------------------------------------
     6. Klaviyo email capture (placeholder)
        Replace with Klaviyo's embedded form or API post once LIST_ID is set.
     ------------------------------------------------------------------------ */
  var klaviyoForms = root.querySelectorAll('[data-stryp-klaviyo]');
  klaviyoForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var listId = form.getAttribute('data-list-id');
      var status = form.querySelector('[data-stryp-klaviyo-status]');

      if (!listId || listId === 'LIST_ID') {
        if (status) status.textContent = 'Email capture not yet wired. Install Klaviyo, set data-list-id.';
        return;
      }

      var emailInput = form.querySelector('input[type="email"]');
      var email = emailInput ? emailInput.value.trim() : '';
      if (!email) return;

      // Klaviyo client-side subscribe endpoint (post-install).
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(listId.split(':')[0] || ''), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: {
              list: { data: { type: 'list', id: listId.split(':')[1] || listId } }
            }
          }
        })
      }).then(function () {
        if (status) status.textContent = 'Thanks. Check your inbox — your $5 code is on the way.';
        form.reset();
      }).catch(function () {
        if (status) status.textContent = 'Something went wrong. Try again.';
      });
    });
  });
})();
